import { RestProvider, RestService } from '../rest/rest.service';
import { Models } from '@ibexfusion/models';
import { RestfulService } from '../rest/restful';
import { Injectable } from '@angular/core';

@Injectable()
export class BannerService extends RestfulService<Models.Banner> {

  constructor(public restService: RestService) {
    super(Models.Banner);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('banners');
  }

}
